import { motion } from "framer-motion";

import halalFoods from "../assets/clients/hilal.png";
import shangrila from "../assets/clients/shangrila.png";
import cocaCola from "../assets/clients//coca-cola.svg";
import ismailIndustries from "../assets/clients/ismail.png";
import soyaSupreme from "../assets/clients/soyasupreme.png";
import shabbirTiles from "../assets/clients/shabbirtiles.jpg";
import indusMotors from "../assets/clients/indusmotors.png";
import thalLimited from "../assets/clients/thallimited.png";
import thalEngineering from "../assets/clients/thalengineering.png";
import karamCeramics from "../assets/clients/karamceramics.png";
import khaadi from "../assets/clients/khaadi.svg";
import fineDaily from "../assets/clients/finedaily.png";
import mehranSpice from "../assets/clients/mehranfoods.png";
import unityFoods from "../assets/clients/unityfoods.jpg";
import upsLogistics from "../assets/clients/ups.png";
import dhl from "../assets/clients/dhl.svg";
import ssgc from "../assets/clients/ssgs.jpg";
import alKaram from "../assets/clients/alkaram.jpg";
import mezanTea from "../assets/clients/mezan.jpg";
import shalimarFoods from "../assets/clients/shalimar.jpg";
import habibOil from "../assets/clients/habib.png";
import kosarlac from "../assets/clients/kosarlac.jpg";
import sunridgeFoods from "../assets/clients/sunridge.jpg";
import pakola from "../assets/clients/pakola.png";
import dilPasand from "../assets/clients/dilpasand.png";
import luckyTextile from "../assets/clients/lucky.png";

const clients = [
  { name: "Halal Foods", logo: halalFoods },
  { name: "Shangrila Foods", logo: shangrila },
  { name: "Coca-Cola", logo: cocaCola },
  { name: "Ismail Industries", logo: ismailIndustries },
  { name: "Soya Supreme", logo: soyaSupreme },
  { name: "Shabbir Tiles", logo: shabbirTiles },
  { name: "Indus Motors", logo: indusMotors },
  { name: "Thal Limited", logo: thalLimited },
  { name: "Thal Engineering", logo: thalEngineering },
  { name: "Karam Ceramics", logo: karamCeramics },
  { name: "Khaadi", logo: khaadi },
  { name: "Fine Daily", logo: fineDaily },
  { name: "Mehran Spice & Foods", logo: mehranSpice },
  { name: "Unity Foods Ltd", logo: unityFoods },
  { name: "UPS Logistics", logo: upsLogistics },
  { name: "DHL", logo: dhl },
  { name: "SSGC", logo: ssgc },
  { name: "Al Karam Textile", logo: alKaram },
  { name: "Mezan Tea", logo: mezanTea },
  { name: "Shalimar Foods", logo: shalimarFoods },
  { name: "Habib Oil", logo: habibOil },
  { name: "Kosarlac Paints", logo: kosarlac },
  { name: "Sunridge Foods", logo: sunridgeFoods },
  { name: "Pakola", logo: pakola },
  { name: "Dil Pasand", logo: dilPasand },
  { name: "Lucky Textile", logo: luckyTextile },
];

const doubled = [...clients, ...clients];

export default function Clientele() {
  return (
    <section className="py-16 bg-white border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-center gap-3 mb-2">
            <span className="block w-8 h-px bg-brand-green" />
            <span className="text-brand-green text-xs uppercase tracking-[0.2em] font-semibold">Trusted By</span>
            <span className="block w-8 h-px bg-brand-green" />
          </div>
          <p className="text-gray-400 text-sm">Packaging solutions delivered to industry leaders across Pakistan</p>
        </motion.div>
      </div>

      {/* Marquee track */}
      <div className="relative">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex overflow-hidden">
          <motion.div
            className="flex gap-16 items-center"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 60,
              ease: "linear",
              repeat: Infinity,
            }}
            style={{ width: "max-content" }}
          >
            {doubled.map((client, i) => (
              <div
                key={i}
                className="flex-shrink-0 flex items-center justify-center w-44 h-24 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
                title={client.name}
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-h-16 max-w-[150px] w-auto object-contain"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}